import React, {Component} from 'react';
import {Route, Switch, withRouter, Redirect} from 'react-router-dom';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { updateObject } from '../../global/utility';

import * as billboardActions from '../actions/index';
import * as userActions from '../../global/user/actions/index';

import LoadingIndicator from '../../global/loading_indicator/loading_indicator';
import Button from '../../global/button/button';
import TextField from '../../global/text_field/text_field';
import logger from '../../global/logger';

class BillboardPairNewDeviceView extends Component {

    state = {
        code: "",
    }

    componentDidMount() {
        
    }

    componentWillUnmount() {
        
    }

    componentDidUpdate(prevProps) {
        
    }

    changeHandler(event, property_name) {
        
        this.setState(updateObject(this.state, {code: event.target.value}));
        logger.log("code: " + this.state.code);
    }

    submitCode() {
        this.props.onSubmitCode(this.state.code);
        logger.log("submitCode: " + this.state.code);
    }

    render () {
        
        let content = (
            <div>
                <p className="text-gray-500 text-xl mb-2">Pair New Device</p>
                <br />
                <TextField label="" property_name="code" value={this.state.code} changeHandler={(event) => this.changeHandler(event, "code")} placeholder="Enter a code" />
                <Button id="send_button" disabled={ this.state.code.length == 0} width="w-full" text="Send" clickEvent={() => this.submitCode()} />
            </div>
        );

        if (this.props.submitting_code || this.props.loading_devices) {
            content = (
                <LoadingIndicator />
            )
        }

        return content;
    }
}

const mapStateToProps = state => {
    return {
        loading_devices: state.billboard.loading_devices,
        submitting_code: state.billboard.submitting_code,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onFetchDevices: () => dispatch(billboardActions.fetchDevices()),
        onSubmitCode: (code) => dispatch(billboardActions.submitCode(code)),
        onUpdateAuthToken: (callback) => dispatch(userActions.updateAuthToken(callback))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BillboardPairNewDeviceView));